import {
  fetch,
  extractHubURL
} from '../../utils/dataAccess';

export function error(error) {
  return { type: 'COMPANY_CANDIDATE_SHOW_ERROR', error };
}

export function loading(loading) {
  return { type: 'COMPANY_CANDIDATE_SHOW_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'COMPANY_CANDIDATE_SHOW_SUCCESS', retrieved };
}

export function retrieve(id) {
  return dispatch => {
    dispatch(loading(true));

    return fetch(id)
      .then(response =>
          ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch({ type: 'COMPANY_CANDIDATE_SHOW_RESET' });
    dispatch(error(null));
    dispatch(loading(false));
  };
}
